import * as t from 'utils/combinatorTypes';
import { CATALOG_DATA_TYPE } from './catalogConstants';

export const CATALOG_EMPTY_CRITERIA_PROPERTY = {
  comparatorType: '',
  dataType: 'user',
  field: '',
  fieldType: '',
  value: '',
};

export const CATALOG_EMPTY_SEARCH_COMBO = {
  combinator: t.AND,
  searchQueries: [CATALOG_EMPTY_CRITERIA_PROPERTY],
};

export const CATALOG_EMPTY_SEARCH_QUERY = {
  dataType: CATALOG_DATA_TYPE,
  searchCombo: CATALOG_EMPTY_SEARCH_COMBO,
};

export const CATALOG_EMPTY_SEARCH_GROUP = {
  combinator: t.OR,
  searchQueries: [CATALOG_EMPTY_SEARCH_QUERY],
};
